import { Reveal } from "./Reveal";

export const SectionStrip = ({ icon: Icon, title, text, button = true, testid }) => (
  <Reveal>
    <div
      data-testid={testid}
      className="mt-14 flex flex-col gap-5 border-2 border-gold/60 bg-panel p-7 md:flex-row md:items-center md:justify-between md:p-8"
    >
      <div className="flex items-stretch gap-5">
        <span className="hazard-thin w-2.5 shrink-0" aria-hidden="true" />
        <Icon size={32} strokeWidth={1.5} className="shrink-0 self-center text-gold" />
        <div className="self-center">
          <p className="font-heading text-2xl uppercase leading-tight tracking-wide text-gold md:text-3xl">{title}</p>
          <p className="mt-1.5 max-w-xl text-sm font-medium capitalize leading-relaxed text-white/75 md:text-base">{text}</p>
        </div>
      </div>
      {button && (
        <a
          href="#contact"
          data-testid={`${testid}-button`}
          className="btn-brutal shadow-hard-sm w-fit shrink-0 bg-gold px-7 py-3 font-heading text-xl uppercase tracking-wide text-ink"
        >
          Get a Free Quote
        </a>
      )}
    </div>
  </Reveal>
);
